import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

export interface BannerMenuData {
  title: string;
  url: string;
  page?: string;
  modal: string;
}

@Component({
  selector: 'fcp-banner-menu',
  templateUrl: './banner-menu.component.html',
  styleUrls: ['./banner-menu.component.scss'],
})
export class BannerMenuComponent {
  @ViewChild('bannerMenu', { static: true }) bannerMenu: ElementRef;
  @Input() public list: Array<BannerMenuData>;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();

  public emitClick(modal: string): void {
    this.clicked.emit(modal);
  }

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(from?: any) {
    let bannerPosition = 0;
    const bannerContent = document.getElementsByClassName('banner__content')[0];
    const newBannerContent = document.getElementsByClassName(
      'new-banner__content'
    )[0];
    const bannerElement: any = bannerContent ? bannerContent : newBannerContent;
    const bannerMenuOffsetHeight = this.bannerMenu.nativeElement.offsetHeight;
    if (bannerElement) {
      bannerPosition = bannerElement.clientHeight;
    }
    if (bannerElement && bannerMenuOffsetHeight) {
      bannerPosition = bannerElement.offsetHeight - bannerMenuOffsetHeight;
    }
    if (window.pageYOffset >= bannerPosition) {
      this.bannerMenu.nativeElement.classList.add('position-fixed');
    } else {
      this.bannerMenu.nativeElement.classList.remove('position-fixed');
    }
  }
}
